import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { CoverageZonesApiAdapter } from '../adapters/CoverageZonesApiAdapter';
import { Filters } from '../models/Filters';
import { Service } from '../services/Service';

export const useCouriers = (filters: Filters = {}) => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new CoverageZonesApiAdapter(httpClient);
    const service = new Service(apiAdapter);

    const { data, isLoading, error, refetch, isPending } = useQuery({
        queryKey: ['couriers', filters],
        queryFn: () => service.getCouriers(filters),
        staleTime: 5 * 60 * 1000, // 5 minutos
    });

    return {
        couriers: data ?? [],
        isLoading: isLoading || isPending,
        error,
        refetch,
        total: data?.length ?? 0,
    };
};

